import React, { HTMLAttributes } from 'react';

import { BaseMessage } from '../BaseMessage/BaseMessage';
import styles from './EmptySearch.css';

const mapTypeName = {
    image: 'Изображения',
    audio: 'Музыка',
    video: 'Видео',
    document: 'Документы',
    pdf: 'Файлы PDF',
    spreadsheet: 'Таблицы',
    presentation: 'Презентации',
    archive: 'Архивы',
    folder: 'Папки',
};

export const getSearchData = ({ searchType, searchText }: { searchType?: string; searchText?: string }) => {
    const type = searchType && mapTypeName[searchType];

    if (type && searchText) {
        return {
            title: `По запросу «${searchText}» ${type.toLowerCase()} не ${type === mapTypeName.audio ? 'найдена' : 'найдены'}`,
            text: 'Проверьте правильность написания или выберите другой тип файлов',
        };
    }

    if (type) {
        return {
            title: `${type} не ${type === mapTypeName.audio ? 'найдена' : 'найдены'}`,
            text: 'Попробуйте использовать поиск по названию или выберите другой тип файлов',
        };
    }

    return {
        title: `По запросу «${searchText}» ничего не найдено`,
        text: 'Проверьте правильность написания или используйте другой запрос',
    };
};

interface IProps extends HTMLAttributes<HTMLDivElement> {
    searchText?: string;
    searchType?: string;
    isMobile?: boolean;
}

export const EmptySearch: React.FC<IProps> = ({ searchText, searchType, ...rest }) => {
    const { title, text } = getSearchData({ searchType, searchText });

    return <BaseMessage img={<div className={styles.image} />} title={title} text={text} {...rest} />;
};

EmptySearch.displayName = 'EmptySearch';
